import script from "./itemsClassify.vue?vue&type=script&setup=true&lang=js"
export * from "./itemsClassify.vue?vue&type=script&setup=true&lang=js"

import "./itemsClassify.vue?vue&type=style&index=0&id=bf80e0e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf80e0e8"]])

export default __exports__